import React from 'react';
import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Typography,
} from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Close, ExpandLess } from '@material-ui/icons';
import Drawer, { DrawerProps } from './Drawer';

export const closedDrawerHeight = 57;

const useStyles = makeStyles(() => ({
  accordion: {
    maxHeight: (props: PeekADrawerProps) => props.isMobile ? '90vh' : '100vh',
    height: (props: PeekADrawerProps) => props.isMobile ? 'auto' : '100vh',
    width: (props: PeekADrawerProps) => props.isMobile ? '100vw' : '30vw',
  }
}));

const Title = withStyles({
  root: {
    color: '#304153',
    fontFamily: 'OpenSans',
    fontSize: '22px',
  },
})(Typography);

const Accordion = withStyles({
  root: {
    backgroundColor: 'inherit',
    display: 'flex',
    flexDirection: 'column',
  },
  rounded: {
    borderRadius: "25px 25px 0 0",
    "&:first-child, &:last-child": {
      borderRadius: "25px 25px 0 0",
    },
  },
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    height: `${closedDrawerHeight}px`,
  },
  content: {
    justifyContent: 'center',
  },
})(MuiAccordionSummary);

export type PeekADrawerProps = {
  collapsedIcon?: React.ReactNode;
  details: React.ReactNode;
  expanded: boolean;
  expandedIcon?: React.ReactNode;
  onChange: (event: React.ChangeEvent<{}>, expanded: boolean) => void;
  show: boolean;
  title: React.ReactNode;
  isMobile: boolean;
} & DrawerProps;

const PeekADrawer = (props: PeekADrawerProps) => {
  const classes = useStyles(props);
  const {
    collapsedIcon = <ExpandLess />,
    details,
    expanded,
    expandedIcon = <Close />,
    onChange,
    show,
    title,
    isMobile,
  } = props;
  return (
    <Drawer
      anchor={isMobile ? "bottom" : "left"}
      open={show}
      closeIcon={null}
      PaperProps={{
        variant: isMobile ? 'outlined' : undefined,
        style: {
          borderRadius: isMobile ? "25px 25px 0 0" : "0 0 0 0",
        }
      }}
    >
      <Accordion
        className={classes.accordion}
        square={!isMobile}
        expanded={isMobile ? expanded : true}
        onChange={onChange}
        elevation={isMobile ? 10 : 0}
        TransitionProps={{style: {overflow: 'auto'}}}
      >
        <AccordionSummary expandIcon={expanded ? expandedIcon : collapsedIcon}>
          <Title variant='body1'>
            {title}
          </Title>
        </AccordionSummary>
        <MuiAccordionDetails>
          {details}
        </MuiAccordionDetails>
      </Accordion>
    </Drawer>
  );
};

export default PeekADrawer;
